import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-10 md:py-14">
          <div className="rounded-xl bg-background-50 px-6 md:px-8 py-8">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
              <div className="lg:w-1/4">
                <Link to="/" className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-store-2-line text-xl text-primary-500"></i>
                  </div>
                  <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                    SuperbuySheet
                  </span>
                </Link>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Your trusted resource for Superbuy Spreadsheet tools, templates, and guides. Helping global shoppers make smarter purchasing decisions.
                </p>
              </div>

              <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
                <div>
                  <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Quick Links</h4>
                  <ul className="space-y-2">
                    <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">Home</Link></li>
                    <li><Link to="/article/superbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">Complete Guide</Link></li>
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">Main Website</a></li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Top Categories</h4>
                  <ul className="space-y-2">
                    {categories.slice(0, 5).map((cat) => (
                      <li key={cat.name}>
                        <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">{cat.name}</a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">More Categories</h4>
                  <ul className="space-y-2">
                    {categories.slice(5, 10).map((cat) => (
                      <li key={cat.name}>
                        <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">{cat.name}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span>&copy; {new Date().getFullYear()} SuperbuySpread.hair</span>
                <span className="hidden sm:inline">|</span>
                <Link to="/" className="hover:text-primary-500 transition-colors duration-150">Home</Link>
                <span className="hidden sm:inline">|</span>
                <Link to="/article/superbuy-spreadsheet-complete-guide" className="hover:text-primary-500 transition-colors duration-150">Guide</Link>
              </div>
              <div className="flex items-center gap-4">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-background-200/80 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200">
                  <i className="ri-external-link-line text-sm text-foreground-600"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-background-200/80 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200">
                  <i className="ri-shopping-bag-line text-sm text-foreground-600"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}